import { render, staticRenderFns } from "./WorkRecords.vue?vue&type=template&id=fc180a18&scoped=true"
import script from "./WorkRecords.vue?vue&type=script&lang=js"
export * from "./WorkRecords.vue?vue&type=script&lang=js"
import style0 from "./WorkRecords.vue?vue&type=style&index=0&id=fc180a18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc180a18",
  null
  
)

export default component.exports